import QuestionnaireForm from 'app/features/questionnaires/components/QuestionnaireForm';
import { useSelector } from 'react-redux';

import { uploadFields } from './uploadFields';
import { selectCovidRelief } from '../slice';

export interface CovidReliefAttachmentsProps {}

export default function CovidReliefAttachments(
  props: CovidReliefAttachmentsProps,
) {
  const initialState = useSelector(selectCovidRelief);

  return (
    <div>
      <QuestionnaireForm
        defautlValues={initialState.values}
        fields={uploadFields}
        hideFooter
      />
    </div>
  );
}
